import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */

export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },

  {
    path: "/user_agreement",
    component: () => import("@/views/userAgreement/user_agreement"),
    hidden: true
  },

  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true
  },

  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    name: "home",
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/dashboard/yjbl_order_list"),
        meta: { title: "云居-酒店文旅", icon: "", pop: "F" }
      }
    ]
  }
];

export const asyncRouterMap = [
  {
    path: "/",
    component: Layout,
    // redirect: '/dashboard',
    name: "home",
    meta: { title: "首页", icon: "首页仪表盘-0", pop: "F" },
    // alwaysShow: true, // 当二级目录只有一个时,也显示一级目录
    children: [
      //  {
      //    path: "/dashboard",
      //    name: "dashboard",
      //    component: () => import("@/views/dashboard/index"),
      //    meta: {
      //      title: "首页仪表盘",
      //      icon: "首页仪表盘-0",
      //      pop: "F"
      //    }
      //  },
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/dashboard/yjbl_order_list"),
        meta: { title: "云居-酒店文旅", icon: "", pop: "F" }
      }
    ]
  },

  // businessManagement 数智通讯管理
  {
    path: "/businessManagement",
    component: Layout,
    name: "businessManagement",
    alwaysShow: true, // 当二级目录只有一个时,也显示一级目录
    meta: {
      title: "数智通信管理",
      icon: "数智通讯管理-0",
      pop: "T"
    },
    children: [
      // {
      //   path: "/businessManagement/businessInfo",
      //   name: "businessInfo",
      //   component: () => import("@/views/businessManagement/businessInfo"),
      //   meta: { title: "企业信息", icon: "", pop: "F" }
      // },
      // {
      //   path: "/businessManagement/PBX_IPPBX_Access",
      //   name: "PBX_IPPBX_Access",
      //   component: () => import("@/views/businessManagement/PBX_IPPBX_Access"),
      //   meta: { title: "交换机接入", icon: "", pop: "F" }
      // },
      {
        path: "/businessManagement/organizational_management",
        name: "organizational_management",
        component: () =>
          import("@/views/businessManagement/organizational_management"),
        meta: { title: "组织通信管理", icon: "", pop: "T" }
      },
      //  {
      //    path: "/businessManagement/user_management",
      //    name: "user_management",
      //    component: () =>
      //      import("@/views/businessManagement/user_management"),
      //    meta: { title: "用户分机管理", icon: "", pop: "T" }
      //  },
      {
        path: "/businessManagement/terminal_management",
        name: "terminal_management",
        component: () =>
          import("@/views/businessManagement/terminal_management"),
        meta: { title: "用户分机管理", icon: "", pop: "T" }
      },
      {
        path: "/businessManagement/device_center_control",
        name: "device_center_control",
        component: () =>
          import("@/views/businessManagement/device_center_control"),
        meta: { title: "终端注册管理", icon: "", pop: "T" }
      },
      {
        path: "/businessManagement/extension_call_log",
        name: "extension_call_log",
        component: () =>
          import("@/views/businessManagement/extension_call_log"),
        meta: { title: "通话记录日志", icon: "", pop: "T" }
      },
      {
        path: "/businessManagement/call_log",
        name: "call_log",
        component: () => import("@/views/businessManagement/call_log"),
        meta: { title: "通话记录管理", icon: "", pop: "T" }
      },
      {
        path: "/businessManagement/customer_communication_management",
        name: "customer_communication_management",
        component: () =>
          import("@/views/businessManagement/customer_communication_management"),
        meta: { title: "客户通信管理", icon: "", pop: "T" }
      }
      //  {
      //    path: "/businessManagement/communication_resource",
      //    name: "communication_resource",
      //    component: () =>
      //      import("@/views/businessManagement/communication_resource"),
      //    meta: { title: "通讯资源管理", icon: "", pop: "T" }
      //  },
      //  {
      //    path: "/businessManagement/call_log",
      //    name: "call_log",
      //    component: () =>
      //      import("@/views/businessManagement/call_log"),
      //    meta: { title: "通信记录管理", icon: "", pop: "T" }
      //  }
    ]
  },

  // appCenter AI智能体应用中心
  {
    path: "/appCenter",
    component: Layout,
    name: "appCenter",
    alwaysShow: true, // 当二级目录只有一个时,也显示一级目录
    meta: {
      title: "AI智能体应用中心",
      icon: "AI智能体-0",
      pop: "T"
    },
    children: [
      {
        path: "/appCenter/ai_agent_lifecycle_card",
        name: "ai_agent_lifecycle_card",
        component: () => import("@/views/appCenter/ai_agent_lifecycle_card"),
        meta: {
          title: "Al-Agent智能体",
          icon: "",
          pop: "T"
        }
      },
      {
        path: "/appCenter/intelligent_agent_task_center",
        name: "intelligent_agent_task_center",
        component: () =>
          import("@/views/appCenter/intelligent_agent_task_center"),
        meta: { title: "智能体任务中心", icon: "", pop: "T" }
      },
      {
        path: "/appCenter/app_market",
        name: "app_market",
        component: () => import("@/views/appCenter/app_market"),
        meta: { title: "智能体应用市场", icon: "", pop: "T" }
      }
    ]
  },

  // SecurityAudit 安全管控及通信审计
  {
    path: "/SecurityAudit",
    component: Layout,
    name: "SecurityAudit",
    alwaysShow: true, // 当二级目录只有一个时,也显示一级目录
    meta: {
      title: "通信安全管控",
      icon: "安全管控-0",
      pop: "T"
    },
    children: [
      {
        path: "/SecurityAudit/user_security_control",
        name: "user_security_control",
        component: () => import("@/views/SecurityAudit/user_security_control"),
        meta: {
          title: "用户安全管控",
          icon: "",
          pop: "T"
        }
      },
      {
        path: "/SecurityAudit/terminal_security_management",
        name: "terminal_security_management",
        component: () =>
          import("@/views/SecurityAudit/terminal_security_management"),
        meta: { title: "终端安全管理", icon: "", pop: "T" }
      },
      {
        path: "/SecurityAudit/call_audit_analysis",
        name: "call_audit_analysis",
        component: () => import("@/views/SecurityAudit/call_audit_analysis"),
        meta: { title: "通话审计分析", icon: "", pop: "T" }
      },
      {
        path: "/SecurityAudit/sms_audit_management",
        name: "sms_audit_management",
        component: () => import("@/views/SecurityAudit/sms_audit_management"),
        meta: { title: "短信审计管理", icon: "", pop: "T" }
      },
      {
        path: "/SecurityAudit/end_to_end_message_audit",
        name: "end_to_end_message_audit",
        component: () =>
          import("@/views/SecurityAudit/end_to_end_message_audit"),
        meta: { title: "端到端消息审计", icon: "", pop: "T" }
      },
      {
        path: "/SecurityAudit/comprehensive_security_strategy",
        name: "comprehensive_security_strategy",
        component: () =>
          import("@/views/SecurityAudit/comprehensive_security_strategy"),
        meta: { title: "综合安全策略", icon: "", pop: "T" }
      },
      {
        path: "/SecurityAudit/sensitive_word_management",
        name: "sensitive_word_management",
        component: () =>
          import("@/views/SecurityAudit/sensitive_word_management"),
        meta: { title: "敏感词管理", icon: "", pop: "T" }
      }
    ]
  },

  {
    path: "/hotel",
    component: Layout,
    name: "hotel",
    alwaysShow: true, // 当二级目录只有一个时,也显示一级目录
    meta: { title: "智慧酒店管理", icon: "酒店管理-0", pop: "T" },
    children: [
      {
        path: "/hotel/hotel_Information_management",
        name: "hotel_Information_management",
        component: () => import("@/views/hotel/hotel_Information_management"),
        meta: { title: "酒店信息管理", icon: "", pop: "T" }
      },
      {
        path: "/hotel/ai_assistant_configuration",
        name: "ai_assistant_configuration",
        component: () => import("@/views/hotel/ai_assistant_configuration"),
        meta: { title: "AI助手配置", icon: "", pop: "T" }
      },
      // {
      //   path: "/hotel/hotel_room_type_management",
      //   name: "hotel_room_type_management",
      //   component: () => import("@/views/hotel/hotel_room_type_management"),
      //   meta: { title: "酒店房型管理", icon: "", pop: "T" }
      // },
      {
        path: "/hotel/room_list",
        name: "room_list",
        hidden: true,
        component: () => import("@/views/hotel/room_list"),
        meta: { title: "房间列表", icon: "", pop: "T" }
      },
      {
        path: "/hotel/room_type_tag_management",
        name: "room_type_tag_management",
        hidden: true,
        component: () => import("@/views/hotel/room_type_tag_management"),
        meta: { title: "便签管理", icon: "", pop: "T" }
      },
      {
        path: "/hotel/hotel_room_management",
        name: "hotel_room_management",
        component: () => import("@/views/hotel/hotel_room_management"),
        meta: { title: "酒店房间管理", icon: "", pop: "T" }
      },
      {
        path: "/hotel/room_center_control",
        name: "room_center_control",
        hidden: true,
        component: () => import("@/views/hotel/room_center_control"),
        meta: { title: "房间中控管理", icon: "", pop: "T" }
      },
      {
        path: "/hotel/room_customer_demand",
        name: "room_customer_demand",
        hidden: true,
        component: () => import("@/views/hotel/room_customer_demand"),
        meta: { title: "房间客控管理", icon: "", pop: "T" }
      },
      {
        path: "/hotel/hotel_service_configuration",
        name: "hotel_service_configuration",
        component: () => import("@/views/hotel/hotel_service_configuration"),
        meta: { title: "酒店服务配置", icon: "", pop: "T" }
      },
      {
        path: "/hotel/service_introduction",
        name: "service_introduction",
        component: () => import("@/views/hotel/service_introduction"),
        meta: { title: "服务介绍配置", icon: "", pop: "T" }
      },
      {
        path: "/hotel/customer_demand_list",
        name: "customer_demand_list",
        component: () => import("@/views/hotel/customer_demand_list"),
        meta: { title: "酒店客需管理", icon: "", pop: "T" }
      }
      //  {
      //    path: "/hotel/member_level_list",
      //    name: "member_level_list",
      //    component: () =>
      //      import("@/views/hotel/member_level_list"),
      //    meta: { title: "会员等级列表", icon: "", pop: "T" }
      //  }
    ]
  },

  // operation 智能运营管理
  {
    path: "/operation",
    component: Layout,
    name: "operation",
    alwaysShow: true, // 当二级目录只有一个时,也显示一级目录
    meta: { title: "酒店运营管理", icon: "运营管理-0", pop: "T" },
    children: [
      {
        path: "/operation/ad_management",
        name: "ad_management",
        component: () => import("@/views/operation/ad_management"),
        meta: { title: "酒店广告管理", icon: "", pop: "T" }
      },
      {
        path: "/operation/tv_channel_management",
        name: "tv_channel_management",
        component: () => import("@/views/operation/tv_channel_management"),
        meta: { title: "电视频道管理", icon: "", pop: "T" }
      },
      {
        path: "/operation/problem_feedback",
        name: "problem_feedback",
        component: () => import("@/views/operation/problem_feedback"),
        meta: { title: "一键吐槽管理", icon: "", pop: "T" }
      }
    ]
  },

  // system 系统管理
  {
    path: "/system",
    component: Layout,
    name: "system",
    alwaysShow: true, // 当二级目录只有一个时,也显示一级目录
    meta: { title: "系统管理", icon: "系统对接-0", pop: "T" },
    children: [
      {
        path: "/system/system_user",
        name: "system_user",
        component: () => import("@/views/system/system_user"),
        meta: { title: "系统用户管理", icon: "", pop: "T" }
      },
      {
        path: "/system/system_group",
        name: "system_group",
        component: () => import("@/views/system/system_group"),
        meta: { title: "系统角色管理", icon: "", pop: "T" }
      },
      {
        path: "/system/system_module",
        name: "system_module",
        component: () => import("@/views/system/system_module"),
        meta: { title: "系统模块管理", icon: "", pop: "T" }
      }
    ]
  },

  // operationLog 操作日志
  // {
  //   path: "/operationLog",
  //   component: Layout,
  //   name: "operationLog",
  //   alwaysShow: true, // 当二级目录只有一个时,也显示一级目录
  //   meta: { title: "操作日志", icon: "操作日志", pop: "T" },
  //   children: [
  //     {
  //       path: "/operationLog/operation_log",
  //       name: "operation_log",
  //       component: () => import("@/views/operationLog/operation_log"),
  //       meta: { title: "操作日志", icon: "", pop: "T" }
  //     }
  //   ]
  // },
  {
    path: "*",
    redirect: "/404",
    hidden: true,
    meta: { pop: "F" }
  }
  // 404 page must be placed at the end !!!
];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    // routes: constantRoutes.concat(asyncRouterMap)
    routes: constantRoutes
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
